import { MultimediaLinkUploadResponse } from '../../../@types/multimedia-types'
import { Attachment } from '../../../@types/types'

export const multimediaLinkUploadResponseToApp = ({
  id,
  linkUrl,
  title,
  source,
  link,
  floorplan,
}: MultimediaLinkUploadResponse): Attachment => ({
  id,
  linkUrl,
  title,
  source,
  link,
  floorplan,
})
